<button type="button"
        mat-button
        *ngFor="let localAction of getLocalActionsIterable()"
        [ngClass]="getClass(localAction.Id)"
        (click)="localActionClicked($event, localAction.Id, localActions[localAction.Id])">
  <i></i>{{ getLocalActionSimple(localAction.Id).Title }}
</button>
